<template>
  <b-modal
    id="modaluploadmultiaddress"
    hide-footer
    title="Multi-location Radius Counts"
    size="lg"
  >
    <div id="ct_geo_SelectFile">
      <b-container v-show="step == 'file'">
        <!--<input id="ct_geo_filename" readonly="true" value="{{uploadfile.name}}"/>-->
        <br />
        You must upload a file with all of the addresses you wish to run radius
        counts for.
        <b-link
          :href="
            $store.getters['config/link']('uploadMultipleAddressTemplates')
          "
          target="_blank"
          >Use our template</b-link
        >, or, make sure your file follows these guidelines:
        <br />
        <div id="ct_geo_UploadFail" style="color: Red; display: none"></div>
        <ul class="vertical">
          <li>File must be Microsoft Excel file (97 or newer)</li>
          <li>
            File must contain the following columns:
            <ul class="lower-alpha" style="margin-top: 5px">
               <li style="margin-right: 20px">
                Keycode<br/><em>Each input location must have a name, which is
                stored as a Key Code, which may not exceed 30 characters</em>
              </li>
              <li>Address</li>
              <li>City</li>
              <li>State</li>
              <li>ZIP</li>
              <li>Distance<br/><em>Distance in miles around each location</em></li>
            </ul>
          </li>
          <li>Address fields (Address, City, State, ZIP) cannot be empty</li>
        </ul>
        <b-form-file
          id="file_input1"
          v-model="uploadfile"
          ref="fileUpload"
        ></b-form-file>
        <br />
        Selected file: {{ uploadfile && uploadfile.name }}
        <div
          style="
            width: 100px;
            margin-top: 10px;
            margin: 0 auto;
            text-align: center;
          "
        >
          <b-btn variant="primary" @click="next" :disabled="nextDisabled"
            >Next</b-btn
          >
        </div>
      </b-container>
      <b-container v-show="step == 'result'">
        <div>
          <table class="table">
            <tr>
              <td v-for="col in uploadlistcolumn">{{ col.ColumnName }}</td>
            </tr>
            <tr v-for="row in items">
              <td v-for="col in row.RowData">{{ col.Data }}</td>
            </tr>
          </table>
        </div>
        <div
          style="
            width: 200px;
            margin-top: 10px;
            margin: 0 auto;
            text-align: center;
          "
        >
          <b-btn @click="back">Back</b-btn>
          <b-btn variant="primary" @click="nextmap" :disabled="nextDisabled"
            >Next</b-btn
          >
        </div>
      </b-container>
    </div>
  </b-modal>
</template>


<script>
import utils from "@/assets/utils/index";
import notificaton from "@/components/common/notification";

export default {
  components: {},
  created() {},
  data() {
    return {
      step: "file",
      radius: "",
      Miles: "",
      AddressName: "",
      uploadfile: null,
      items: [],
      uploadlistcolumn: [],
      targetFileName: "",
      map: null,
      nextDisabled: false,
    };
  },
  computed: {
    geoType() {
      return this.$store.state.geo.geoTypes;
    },
  },
  methods: {
    next() {
      if (!this.uploadfile) {
        notificaton.notice("error", "Please choose a file");
        return false;
      }
      this.nextDisabled = true;
      this.$store.dispatch("order/changeGeoType", this.geoType.Radius.Code);
      let zipFormData = new FormData();
      zipFormData.append("filename", this.uploadfile, this.uploadfile.filename);
      this.$http.post("Common/ExcelUploader.ashx", zipFormData).then(
        (resp) => {
          if (resp.body.ResultFlag) {
            this.targetFileName = resp.body.DataSource.TargetFile;
            this.getRecord(resp.body.DataSource.TargetFile);
          } else {
            this.nextDisabled = false;
            notificaton.notice("error", resp.body.ResultMessage);
          }
        },
        (resp) => {
          notificaton.notice("error", "Please try again");
          this.nextDisabled = false;
        }
      );
    },
    getRecord(TargetFileName) {
      // check zip
      this.$http
        .post("PlaceOrder.aspx/GetRecord", {
          filePath: TargetFileName,
          type: 2,
        })
        .then(
          (resp) => {
            this.items = resp.body.d.DataSource.SuccessRow;
            this.uploadlistcolumn = resp.body.d.DataSource.UpLoadListColumn;
            this.step = "result";
            this.nextDisabled = false;
          },
          (resp) => {
            this.nextDisabled = false;
          }
        );
    },
    back() {
      this.step = "file";
      this.$refs.fileUpload.reset();
    },
    nextmap() {
      this.nextDisabled = true;
      let that = this;
      this.map = utils.maps["mapCircle"];
      this.$http
        .post("PlaceOrder.aspx/GetAddressByFile2", {
          FilePath: this.targetFileName,
          type: 1,
        })
        .then(
          (resp) => {
            let data = resp.body.d.DataSource;
            let geoitems = resp.body.d.DataSource.GeoItems;
            for (var geoitem in geoitems) {
              let searchstring =
                geoitems[geoitem].Longitude +
                ":" +
                geoitems[geoitem].Latitude +
                ":2";
              this.$store.commit("order/addAddress", {
                Radius: geoitems[geoitem].Distance,
                AddrSearchString: searchstring,
                AddressLine: geoitems[geoitem].AddressLine,
                AddressName: geoitems[geoitem].KeyCode,
                Latitude: geoitems[geoitem].Latitude,
                Longitude: geoitems[geoitem].Longitude,
              });
              this.$store.commit("order/addGeo", {
                AddressLine: searchstring,
                GeoKeyCode: searchstring,
                GeoKeyDesc: geoitems[geoitem].AddressLine,
                GeoType: that.$store.state.order.GeoType,
              });
            }
            this.$root.$emit("bv::hide::modal", "modaluploadmultiaddress");
            this.$root.$emit("mShowMultiMap");
            this.nextDisabled = false;
            notificaton.notice(
              "info",
              `Total records: ${data.TotalCount} records been found on map,  ${data.FCount} records can't be found on map,`
            );
          },
          (resp) => {
            this.nextDisabled = false;
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
.table {
  max-height: 400px;
  overflow: auto;
  width: 100%;
  border: 1px solid $color-border;
}
</style>



// WEBPACK FOOTER //
// src/components/geo/MUploadMultiAddress.vue